
//Libraries
import { defineComponent, onMounted, ref } from "vue";

export default defineComponent({
  name: "UserGame",
  setup() {
    //Data
    const isLoading = ref<boolean>(true);

    //Lifecycle Hooks

    onMounted(() => {
      setTimeout(() => {
        isLoading.value = false;
      }, 700);
    });

    return {
      isLoading,
    };
  },
});
